import { LEADING_DOT_REGEX } from '../constants/regex';
import FileIcon from 'assets/images/icons/icon-file.png';
import AviIcon from 'assets/images/icons/icon-avi.png';
import ImageIcon from 'assets/images/icons/icon-image.png';
import Mp3Icon from 'assets/images/icons/icon-mp3.png';
import PdfIcon from 'assets/images/icons/icon-pdf.png';
import PptIcon from 'assets/images/icons/icon-pp.png';
import WordIcon from 'assets/images/icons/icon-word.png';
import XlsIcon from 'assets/images/icons/icon-xls.png';
import ZipIcon from 'assets/images/icons/icon-zip.png';
import TextIcon from 'assets/images/icons/icon-txt.png';

export const getAttachmentIcon = (fileType = '') => {
  const type = (fileType || '').toLowerCase().replace(LEADING_DOT_REGEX, '');

  switch (type) {
    case 'avi':
      return AviIcon;
    case 'mp4':
      return AviIcon;
    case 'mp3':
      return Mp3Icon;
    case 'jpg':
      return ImageIcon;
    case 'jpeg':
      return ImageIcon;
    case 'gif':
      return ImageIcon;
    case 'pcx':
      return ImageIcon;
    case 'png':
      return ImageIcon;
    case 'bmp':
      return ImageIcon;
    case 'pdf':
      return PdfIcon;
    case 'ppt':
      return PptIcon;
    case 'pptx':
      return PptIcon;
    case 'doc':
      return WordIcon;
    case 'docx':
      return WordIcon;
    case 'xls':
      return XlsIcon;
    case 'xlsx':
      return XlsIcon;
    case 'zip':
      return ZipIcon;
    case 'tar':
      return ZipIcon;
    case 'rar':
      return ZipIcon;
    case 'lzh':
      return ZipIcon;
    case 'txt':
      return TextIcon;
    default:
      return FileIcon;
  }
};
